import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=a9209b62&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=a9209b62&prod&lang=css"
import style1 from "./Setting.vue?vue&type=style&index=1&id=a9209b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9209b62",
  null
  
)

export default component.exports